import {
  Dialog,
  DialogBody,
  DialogHeader,
  Typography,
} from "@material-tailwind/react";

function AvailabilityPopover({
  open: openDialog,
  handleOpen,
  permanent,
}: {
  open: boolean;
  handleOpen: () => void;
  permanent: () => void;
}) {
  return (
    <Dialog
      placeholder={undefined}
      open={openDialog}
      handler={handleOpen}
      size="sm"
    >
      <DialogHeader placeholder={undefined} className="flex justify-center ">
        <Typography
          placeholder={undefined}
          className="font-medium text-xl mx-auto"
        >
          Set boat off
        </Typography>
      </DialogHeader>
      <hr />
      <DialogBody placeholder={undefined} className="text-center">
        <button
          className="px-5 py-2 rounded-md outline outline-red-500 w-full bg-primary  text-white hover:bg-red-400"
          onClick={() => {
            permanent();
            handleOpen();
          }}
        >
          Turn off
        </button>
        <button
          className="px-5 py-2 rounded-md outline w-full btn mt-2 hover:bg-gray-200"
          onClick={() => handleOpen()}
        >
          Cancel
        </button>
      </DialogBody>
    </Dialog>
  );
}

export default AvailabilityPopover;
